export default {
    namespaced: true,
    state: {
        selected: null,
        items: []
    },
    getters: {
        selected(state) {
            return state.selected
        },
        items(state) {
            return state.items
        }
    },
    mutations: {
        SET_SELECTED(state, value) {
            state.selected = value
        },
        SET_ITEMS(state, value) {
            state.items = value
        }
    },
    actions: {
        selectItem({commit}, value) {
            commit('SET_SELECTED', value)
        },
        setItems({commit}, value) {
            commit('SET_ITEMS', value)
        }
    }
}
